export default {
  en: {
    privacy_section_header: "Privacy",
    privacy_implications: "Privacy Implications",
    privacy_implications_paragraph:
      "All of the privacy implications contained within this Information Model are described in this Section. All of the corresponding concepts and methods for these privacy annotations are defined in the Privacy Framework.",
    confidentiality_level: "Confidentiality Level",
    confidentiality_level_paragraph:
      "All of the privacy classification of the exchanged payloads are described in this Section.",
    ACCESSIBILITY_label: "Accessibility",
    ACCESSIBILITY_def:
      "denotes information about the accessibility personal needs and preferences of the user",
    ANALYTICS_label: "Analytics",
    ANALYTICS_def:
      "denotes information that will be used to support the creation of learning analytics",
    CONTAINER_label: "Container",
    CONTAINER_def:
      "denotes that the child attributes have privacy-sensitive information",
    CREDENTIALS_label: "Credentials",
    CREDENTIALS_def:
      "denotes access control information for the use e.g. password, private key, etc.",
    CREDENTIALSIDREF_label: "CredentialsIdRef",
    CREDENTIALSIDREF_def:
      "denotes reference to/use of an identifier to credentials information for the user",
    DEMOGRAPHICS_label: "Demographics",
    DEMOGRAPHICS_def:
      "denotes information about the demographics of the user e.g. ethnicity, gender, etc.",
    EXTENSION_label: "Extension",
    EXTENSION_def:
      "denotes that proprietary information can be included and so this MAY contain privacy-sensitive information",
    FINANCIAL_label: "Financial",
    FINANCIAL_def:
      "denotes that the information is of a financial nature e.g. bank account, financial aid status, etc.",
    IDENTIFIER_label: "Identifier",
    IDENTIFIER_def:
      "denotes a unique identifier that has been assigned, by some third party, to the user e.g. passport number, social security number, etc.",
    IDENTIFIERREF_label: "IdentifierRef",
    IDENTIFIERREF_def:
      "denotes reference to/use of a unique identifier that has been assigned, by some third party, to the user",
    INSURANCE_label: "Insurance/Assurance",
    INSURANCE_def:
      "denotes that the information is about the insurance life-assurance nature, e.g. type of insurance, etc.",
    LEGAL_label: "Legal",
    LEGAL_def:
      "denotes that the information is of a legal or judicial nature e.g. Will, prison record, etc.",
    MEDICAL_label: "Medical/Healthcare",
    MEDICAL_def:
      "denotes that the information is of a medical, or healthcare-related nature e.g. allergies, blood-type, mobility needs, etc.",
    NA_label: "N/A",
    NA_def:
      "denotes that there are NO PRIVACY IMPLICATIONS for this attribute (this is the default setting)",
    OTHER_label: "Other",
    OTHER_def:
      "denotes privacy sensitive information that is NOT covered by one of the other categories",
    QUALIFICATION_label: "Qualification/Certification",
    QUALIFICATION_def:
      "denotes that the information is about education qualifications, skill-set certifications, microcredentials, etc.",
    PERSONAL_label: "Personal",
    PERSONAL_def:
      "denotes personal information about the user e.g. name, address, etc.",
    SOURCEDID_label: "SourcedId",
    SOURCEDID_def:
      "denotes the interoperability unique identifier that has been assigned and MUST be present for the correct usage of the corresponding 1EdTech specification",
    SOURCEDIDREF_label: "SourcedIdRef",
    SOURCEDIDREF_def:
      "denotes reference to/use of the interoperability unique identifier, sourcedId, to link/point to an associated 1EdTech object",
    UNRESTRICTED_label: "unrestricted",
    UNRESTRICTED_def:
      "there are no privacy concerns (this is the default value).",
    NORMAL_label: "normal",
    NORMAL_def:
      "denotes that privacy sensitive data could be included and so all best practices to secure this data should be used.",
    RESTRICTED_label: "restricted",
    RESTRICTED_def:
      "denotes that some of the data is more sensitive than usual or that many attributes information that when used together create increased vulnerability for identification of the associated individual or group.",
    VERYRESTRICTED_label: "veryrestricted",
    VERYRESTRICTED_def:
      "denotes that the request could contain very sensitive privacy data. Depending on the capabilities of the Provider this very sensitive data may be obfuscated or may not even be present."
  },
  es: {
    privacy_section_header: "Privacidad",
    privacy_implications: "Implicaciones de Privacidad",
    privacy_implications_paragraph:
      "Todas las implicaciones de privacidad referentes a este Modelo de Información se describen en esta Sección. Todos los conceptos y métodos correspondientes a estas anotaciones de privacidad están definidas en el Framework de Privacidad.",
    confidentiality_level: "Nivel de Confidencialidad",
    confidentiality_level_paragraph:
      "Toda la clasificación de privacidad de los datos intercambiados se describen en esta Sección.",
    ACCESSIBILITY_label: "Accessibility",
    ACCESSIBILITY_def:
      "denota información sobre las necesidades y preferencias personales sobre accesibilidad del usuario",
    ANALYTICS_label: "Analytics",
    ANALYTICS_def:
      "denota información que será usada para la creación de analíticas de aprendizaje",
    CONTAINER_label: "Container",
    CONTAINER_def:
      "denota que los atributos decendentes contienen información sensible respecto a la privacidad",
    CREDENTIALS_label: "Credentials",
    CREDENTIALS_def:
      "denota información de control de acceso del usuario, p. ej. contraseña, llave privada, etc.",
    CREDENTIALSIDREF_label: "CredentialsIdRef",
    CREDENTIALSIDREF_def:
      "denota referencia hacia / uso de un identificador de información de credenciales del usuario.",
    DEMOGRAPHICS_label: "Demographics",
    DEMOGRAPHICS_def:
      "denota información demográfica del usuario, p. ej. raza, género, etc.",
    EXTENSION_label: "Extension",
    EXTENSION_def:
      "denota que puede incluir información propietaria y, por lo tanto, PUEDE contener información sensible respecto a la privacidad",
    FINANCIAL_label: "Financial",
    FINANCIAL_def:
      "denota que la información es de naturaleza financiera, p. ej. cuentas bancarias, estado financiero, etc.",
    IDENTIFIER_label: "Identifier",
    IDENTIFIER_def:
      "denota un identificador único que ha sido asignado, por algún tercero, al usuario, p. ej. pasaporte, número de la seguridad social, nif, etc.",
    IDENTIFIERREF_label: "IdentifierRef",
    IDENTIFIERREF_def:
      "denota referencia hacia/uso de un identificador único que ha sido asignado, por algún tercero, al usuario.",
    INSURANCE_label: "Insurance/Assurance",
    INSURANCE_def:
      "denota que la información es de naturaleza aseguradora, p. ej. tipo de seguro, etc.",
    LEGAL_label: "Legal",
    LEGAL_def:
      "denota que la información es de naturaleza legal o judicial, p. ej. Testamento, antecedentes penales, etc.",
    MEDICAL_label: "Medical/Healthcare",
    MEDICAL_def:
      "denota que la información es de naturaleza médica o relacionada con la salud, p. ej. alergias, grupo sanguíneo, necesidades de movilidad, etc.",
    NA_label: "N/A",
    NA_def:
      "denota que NO HAY IMPLICACIONES DE PRIVACIDAD para este atributo (este es el valor por defecto)",
    OTHER_label: "Other",
    OTHER_def:
      "denota información sensible con respecto a la privacidad que NO está contenida en una de las otras categorías",
    QUALIFICATION_label: "Qualification/Certification",
    QUALIFICATION_def:
      "denota que la información es sobre calificaciones educativas, certificaciones, microcredenciales, etc.",
    PERSONAL_label: "Personal",
    PERSONAL_def:
      "denota información personal sobre el usuario, p. ej. nombre, dirección, etc.",
    SOURCEDID_label: "SourcedId",
    SOURCEDID_def:
      "denota el identificador único de interoperabilidad que ha sido asignado y DEBE estar presente para el uso correcto de la especificación 1EdTech correspondiente",
    SOURCEDIDREF_label: "SourcedIdRef",
    SOURCEDIDREF_def:
      "denota referencia hacia/uso de el identificador único de interoperabilidad, sourcedId, para enlazar/apuntar a un objeto 1EdTech asociado",
    UNRESTRICTED_label: "unrestricted",
    UNRESTRICTED_def:
      "No hay problemas de privacidad (este es el valor por defecto).",
    NORMAL_label: "normal",
    NORMAL_def:
      "denota que datos sensibles con respecto a la privacidad pueden ser incluidos y, por tanto, deben usarse todas las medidas para securizar esta información.",
    RESTRICTED_label: "restricted",
    RESTRICTED_def:
      "denota que algunos de los datos son más sensibles de lo habitual o que contiene atributos que usados conjuntamente incrementan la vulnerabilidad de identificar al individuo o grupo asociado.",
    VERYRESTRICTED_label: "veryrestricted",
    VERYRESTRICTED_def:
      "denota que la petición puede contener datos muy sensibles con respecto a la privacidad. Dependiendo de las capacidades del Proveedor estos datos extremadamente sensibles pueden ofuscarse o incluso no estar presentes."
  },
  ca: {
    privacy_section_header: "Privacitat",
    privacy_implications: "Implicacions de Privacitat",
    privacy_implications_paragraph:
      "Totes les implicacions de privacitat referents a aquest Model d'Informació es descriuen en aquesta Secció. Tots els conceptes i mètodes corresponents a aquestes anotacions de privacitat estan definides en el Framework de Privacitat.",
    confidentiality_level: "Nivell de Confidencialitat",
    confidentiality_level_paragraph:
      "Tota la classificació de privacitat de les dades intercanviades es descriuen en aquesta Secció.",
    ACCESSIBILITY_label: "Accessibility",
    ACCESSIBILITY_def:
      "denota informació sobre les necessitats i preferències personals sobre accessibilitat de l'usuari",
    ANALYTICS_label: "Analytics",
    ANALYTICS_def:
      "denota informació que serà usada per a la creació d'analítiques d'aprenentatge",
    CONTAINER_label: "Container",
    CONTAINER_def:
      "denota que els atributs descendents contenen informació sensible respecte a la privacitat",
    CREDENTIALS_label: "Credentials",
    CREDENTIALS_def:
      "denota informació de control de accés de l'usuari, p. ex.. contrasenya, clau privada, etc.",
    CREDENTIALSIDREF_label: "CredentialsIdRef",
    CREDENTIALSIDREF_def:
      "denota referència cap a / ús d'un identificador de informació de credencials de l'usuari.",
    DEMOGRAPHICS_label: "Demographics",
    DEMOGRAPHICS_def:
      "denota informació demogràfica de l'usuari, p. ex.. raça, gènere, etc.",
    EXTENSION_label: "Extension",
    EXTENSION_def:
    "denota que pot incloure informació propietària i, per això, POT contenir informació sensible respecte a la privacitat",
    FINANCIAL_label: "Financial",
    FINANCIAL_def:
      "denota que la informació és de naturalesa financera, p. ex.. comptes bancaris, estat financer, etc.",
    IDENTIFIER_label: "Identifier",
    IDENTIFIER_def:
      "denota un identificador únic que ha estat assignat, per algun tercer, a l'usuari, p. ex. passaport, número de la seguretat social, nif, etc.",
    IDENTIFIERREF_label: "IdentifierRef",
    IDENTIFIERREF_def:
      "denota referència cap a / ús d'un identificador únic que ha estat assignat, per algun tercer, a l'usuari.",
    INSURANCE_label: "Insurance/Assurance",
    INSURANCE_def:
      "denota que la informació és de naturalesa asseguradora, e.g. tipus d'assegurança, etc.",
    LEGAL_label: "Legal",
    LEGAL_def:
      "denota que la informació és de naturalesa legal o judicial, p. ex. Testament, antecedents penals, etc.",
    MEDICAL_label: "Medical/Healthcare",
    MEDICAL_def:
      "denota que la informació és de naturalesa mèdica o relacionada amb la salut, p. ex. al·lèrgies, grup sanguini, necessitats de mobilitat, etc.",
    NA_label: "N/A",
    NA_def:
      "denota que NO HI HA IMPLICACIONS DE PRIVACITAT per aquest atribut (aquest és el valor per defecte)",
    OTHER_label: "Other",
    OTHER_def:
      "denota informació sensible respecte a la privacitat que NO està dins d'una de les altres categories",
    QUALIFICATION_label: "Qualification/Certification",
    QUALIFICATION_def:
      "denota que la informació es sobre qualificacions educatives, certificacions, microcredencials, etc.",
    PERSONAL_label: "Personal",
    PERSONAL_def:
      "denota informació personal sobre l'usuari, p. ex. nom, adreça, etc.",
    SOURCEDID_label: "SourcedId",
    SOURCEDID_def:
      "denota l'identificador únic d'interoperabilitat que ha estat assignat i HA D'estar present per el correcte ús l'especificació 1EdTech corresponent",
    SOURCEDIDREF_label: "SourcedIdRef",
    SOURCEDIDREF_def:
      "denota referència cap a / ús d'un identificador únic d'interoperabilitat, sourcedId, per enllçar/apuntar cap a un objecte 1EdTech associat",
    UNRESTRICTED_label: "unrestricted",
    UNRESTRICTED_def:
      "No hi ha problemes de privacitat (aquest és el valor per defecte).",
    NORMAL_label: "normal",
    NORMAL_def:
      "denota que dades sensibles respecte a la privacitat poden ser inclosos i, per tant, han d'emprar-se totes les mesures per protegir la informació.",
    RESTRICTED_label: "restricted",
    RESTRICTED_def:
      "denota que algunes de les dades són més sensibles de l'habitual o que conté atributs que, emprats conjuntament, incrementen la vulnerabilitat d'identificar a l'individu o grup associat.",
    VERYRESTRICTED_label: "veryrestricted",
    VERYRESTRICTED_def:
      "denota que la petició pot contenir dades molt sensibles respecte a la privacitat. Depenent de les capacitats del Proveïdor aquestes dades extremadament sensibles poden ofuscar-se o inclús no estar presents."
  }

};
